<template>
  <b-card no-body class="border-default">
    <b-card-header
      class="d-flex justify-content-between align-items-center pb-25 text-body"
    >
      <h5>Total Transféré</h5>
    </b-card-header>
    <b-card-body class="text-bold text-capitalize">
      {{ amountToCurrency(localFund.budgets_total) }}
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BBadge, BButton } from "bootstrap-vue";
import { amountToCurrency } from "@/utils/formatAmount";

export default {
  props: {
    deductedFundAmount: {
      type: Object,
      required: true,
    },
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
  },
  data() {
    return {
      localFund: {
        requests_total: 0,
        budgets_total: 0,
      },
    };
  },
  watch: {
    deductedFundAmount: function (val) {
      this.localFund = { ...val };
    },
  },
  methods: {
    amountToCurrency,
  }
};
</script>

<style></style>
